import { globalNavigateControllerRef } from 'widgets/Navigate';
import { NavigateOptions } from 'react-router-dom';

const navigate = (path: string, options?: NavigateOptions) => globalNavigateControllerRef.current?.navigate(path, options);

export default navigate;
